// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3857":"8de70e52bd10d626","9313":"9f47ee80e506e80b"}[chunkId] + ".css";
};